import { KbArticleTpaMap, KbArticleTypeMap } from '../constants';
export function getKbArticleKey(type, tpaId) {
  if (tpaId) {
    const tpaEntry = KbArticleTpaMap.find(entry => entry.type === type && entry.tpaId === tpaId);
    if (tpaEntry) {
      return tpaEntry.articleKey;
    }
  }
  return KbArticleTypeMap[type];
}
//# sourceMappingURL=kb-article-utils.js.map